import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/cities', { params })
  },
  store (formData) {
    return apiClient.post('/cities', formData)
  },
  show (id, params) {
    return apiClient.get(`/cities/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/cities/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/cities/${id}`)
  }
}
